<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :scroll="{ x: 1530 }"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #category1="{ record }">
      <a-tooltip
        :overlayStyle="{ maxWidth: '500px', minWidth: '300px' }"
        overlayClassName="wide-tooltip"
      >
        <template #title>
          <div class="tooltip-content">
            {{
              record.positions.filter(v => v.position - 0 === 1)[0]
                ?.categoryIdInfoName
            }}
          </div>
        </template>
        <div class="list-ellipsis">
          {{
            record.positions.filter(v => v.position - 0 === 1)[0]
              ?.categoryIdInfoName
          }}
        </div>
      </a-tooltip>
    </template>
    <template #category2="{ record }">
      <a-tooltip
        :overlayStyle="{ maxWidth: '500px', minWidth: '300px' }"
        overlayClassName="wide-tooltip"
      >
        <template #title>
          <div class="tooltip-content">
            {{
              record.positions.filter(v => v.position - 0 === 2)[0]
                ?.categoryIdInfoName
            }}
          </div>
        </template>
        <div class="list-ellipsis">
          {{
            record.positions.filter(v => v.position - 0 === 2)[0]
              ?.categoryIdInfoName
          }}
        </div>
      </a-tooltip>
    </template>
    <template #category3="{ record }">
      <a-tooltip
        :overlayStyle="{ maxWidth: '500px', minWidth: '300px' }"
        overlayClassName="wide-tooltip"
      >
        <template #title>
          <div class="tooltip-content">
            {{
              record.positions.filter(v => v.position - 0 === 3)[0]
                ?.categoryIdInfoName
            }}
          </div>
        </template>
        <div class="list-ellipsis">
          {{
            record.positions.filter(v => v.position - 0 === 3)[0]
              ?.categoryIdInfoName
          }}
        </div>
      </a-tooltip>
    </template>
    <template #category4="{ record }">
      <a-tooltip
        :overlayStyle="{ maxWidth: '500px', minWidth: '300px' }"
        overlayClassName="wide-tooltip"
      >
        <template #title>
          <div class="tooltip-content">
            {{
              record.positions.filter(v => v.position - 0 === 4)[0]
                ?.categoryIdInfoName
            }}
          </div>
        </template>
        <div class="list-ellipsis">
          {{
            record.positions.filter(v => v.position - 0 === 4)[0]
              ?.categoryIdInfoName
          }}
        </div>
      </a-tooltip>
    </template>
    <template #category5="{ record }">
      <a-tooltip
        :overlayStyle="{ maxWidth: '500px', minWidth: '300px' }"
        overlayClassName="wide-tooltip"
      >
        <template #title>
          <div class="tooltip-content">
            {{
              record.positions.filter(v => v.position - 0 === 5)[0]
                ?.categoryIdInfoName
            }}
          </div>
        </template>
        <div class="list-ellipsis">
          {{
            record.positions.filter(v => v.position - 0 === 5)[0]
              ?.categoryIdInfoName
          }}
        </div>
      </a-tooltip>
    </template>
    <template #deal="{ record }">
      <div class="tal">
        <a-button type="link" @click="changeVisible(true, record)"
          >查看/编辑</a-button
        >
        <a-popconfirm
          title="确定删除该配置?"
          ok-text="确定"
          cancel-text="取消"
          trigger="click"
          @confirm="() => deleteFun({ ...record })"
          @cancel="cancel"
        >
          <a-button type="link">删除</a-button>
        </a-popconfirm>
      </div>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: '站点',
        dataIndex: 'siteName',
        key: 'siteName',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '终端',
        dataIndex: 'terminalName',
        key: 'terminalName',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '月份',
        dataIndex: 'month',
        key: 'month',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '主商品二级类目',
        dataIndex: 'secondCategoryName',
        key: 'secondCategoryName',
        resizable: true,
        width: 200,
        align: 'center'
      },
      {
        title: '主商品三级类目',
        dataIndex: 'thirdCategoryName',
        key: 'thirdCategoryName',
        resizable: true,
        width: 200,
        align: 'center'
      },
      {
        title: '坑1',
        dataIndex: 'category1',
        slots: { customRender: 'category1' },
        width: 300,
        resizable: true,
        align: 'center'
      },
      {
        title: '坑2',
        dataIndex: 'category2',
        slots: { customRender: 'category2' },
        resizable: true,
        align: 'center',
        width: 300
      },
      {
        title: '坑3',
        slots: { customRender: 'category3' },
        key: 'name',
        resizable: true,
        align: 'center',
        width: 300
      },
      {
        title: '坑4',
        slots: { customRender: 'category4' },
        key: 'name',
        resizable: true,
        align: 'center',
        width: 300
      },
      {
        title: '坑5',
        slots: { customRender: 'category5' },
        key: 'name',
        align: 'center',
        width: 300
      },
      {
        title: '操作',
        slots: { customRender: 'deal' },
        key: 'deal',
        fixed: 'right',
        width: 180
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style>
.list-ellipsis {
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tooltip-content {
  max-height: 200px;
  overflow-y: auto;
  word-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.4;
}
</style>
